import { FaTwitch, FaInstagram, FaYoutube,FaDiscord } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function Footer({setIsMentionVisible}) {
    const date = new Date()
    const annee = date.getFullYear()

    return (
        <>
        <footer id="contact">
                <a href="mailto:contact@polaris-studio.fr" id="mail">contact@polarisstudio.io</a>
                <div class="container_icons">
                    <a href="https://www.instagram.com/polarisstudio______/" target="__blank"><FaInstagram /></a> 
                    <a href="https://www.twitch.tv/polarisstudio______" target="__blank"><FaTwitch /></a>
                    <a href="https://www.youtube.com/channel/UCUOg6L1eUSBzTXi4dsEbTtQ" target="__blank"><FaYoutube /></a>
                    <a href="https://x.com/_polarisstudio_" target="__blank"><FaXTwitter /></a>
                    <a href="https://discord.gg/6zXmHYmtjH" target="__blank"><FaDiscord /></a>
                </div>
                <a onClick={() => setIsMentionVisible(true)} id="mentions">Mentions légales</a>
            
            <p id="marque_blanche">POLARiS Studio - Tous droits réservés {annee} <br/> Sité réalisé par <a href="https://ekleipsi-medias.fr" target='__blank'>EKLEIPSI MEDIAS</a></p>
        </footer>
        </>
    )
}